import { render, staticRenderFns } from "./RecentSchedule.vue?vue&type=template&id=21e64c0e"
import script from "./RecentSchedule.vue?vue&type=script&lang=js"
export * from "./RecentSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e64c0e')) {
      api.createRecord('21e64c0e', component.options)
    } else {
      api.reload('21e64c0e', component.options)
    }
    module.hot.accept("./RecentSchedule.vue?vue&type=template&id=21e64c0e", function () {
      api.rerender('21e64c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/quick/RecentSchedule.vue"
export default component.exports